export enum EnumAliasType {
    JobTheme = 'JOB_THEME',
    Theme = 'THEME',
    Subject = 'SUBJECT',
    Topic = 'TOPIC',
    Subtopic = 'SUBTOPIC'
}